import { render, staticRenderFns } from "./nonbindVip.vue?vue&type=template&id=484f8743&scoped=true"
import script from "./nonbindVip.vue?vue&type=script&lang=js"
export * from "./nonbindVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f8743",
  null
  
)

export default component.exports